import { searchWord } from "../../helpers/common";
import moment from "moment";

export const compareTwo = (array1, array2) => {
    const added = [], removed = [];
    for (const id of array2) {
        if (array1.indexOf(id) < 0) added.push(id);
    }

    for (const id of array1) {
        if (array2.indexOf(id) < 0) removed.push(id);
    }

    return { added, removed };
}

export const getSpec = spec => {
    if (spec) {
        if (spec.hasOwnProperty("width"))
            return { width: parseFloat(spec.width) };
        else if (spec.hasOwnProperty("capacity"))
            return { capacity: parseFloat(spec.capacity) };
    }
    return {};
};

export const sortByPinList = list => {
    const pinList = list.filter(e => e.active === 1);
    const unpinList = list.filter(e => e.active === 0);
    return [...pinList, ...unpinList];
}

export const findEG = (item, filters, timezone) => {
    let isMatched = searchWord(item.equipment_group_name, filters.searchText);

    if (isMatched && filters.hasOwnProperty("egIds") && filters.egIds) {
        isMatched = (filters.egIds.indexOf(item.equipment_group_uuid) >= 0);
    }

    if (isMatched && filters.hasOwnProperty("isRecentlyUpdated")) {
        const { isRecentlyUpdated } = filters;
        isMatched = (() => {
            if (!isRecentlyUpdated) return true;
            const now = moment.utc().tz(timezone);
            return (now.diff(moment.utc(item.crew.start_date), "hours") <= 24);
        })();
    }

    return isMatched;
}